import React,{useEffect} from 'react';
import Card from'./Components/Card/Card.jsx';
import './App.css';
import Text from './Components/Text/Text.jsx';
import Button from './Components/Button/Button.jsx';
function App(){
  useEffect(()=>{
    document.title = 'Lilitha\'s React App';
  },[])
  return (
    <div className='App'>
      <div className='Wrapper'>
      <Text/>
      <div className='Group'>
        <Button text="Try it free 7 days then $20/mo thereafter" backgroundColor={'purple'}/>
        <br/>
        <Card/>
      </div>
      </div>
    </div>

    
  )
}

export default App